import { render, staticRenderFns } from "./DepartmentComponent.vue?vue&type=template&id=246f91a9&"
import script from "./DepartmentComponent.vue?vue&type=script&lang=js&"
export * from "./DepartmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports